import { type FC } from 'react'
import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import Badge from '@segment/matcha/components/Badge'
import ButtonText from '@segment/matcha/components/ButtonText'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CardBase, * as Card from '@segment/matcha/recipes/Card'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `Ready to build cost-effective data pipelines?`,
}

const data = [
  {
    url: `/customer-data-maturity/`,
    badge: `Recipe`,
    heading: `Evaluate your current customer data strategy with this comprehensive quiz`,
    buttonText: `Read the recipe`,
  },
  {
    url: `/docs/`,
    badge: `Recipe`,
    heading: `Learn how to build on Segment with our documentation`,
    buttonText: `Read the recipe`,
  },
  {
    url: `https://segment.com/blog/category/engineers-and-developers/`,
    badge: `Recipe`,
    heading: `Check out our blog for engineers, by engineers for up-to-date data management best practices`,
    buttonText: `Read the recipe`,
  },
]

const Resources: FC = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <StyledSection variant="centered">
        <Section.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Heading variant="h2" tag="h2">
              {copy.heading}
            </CopyText.Heading>
          </CopyTextBase>
        </Section.Copy>

        <Section.Contents>
          <ColumnsWrapper>
            <ColumnTrack columns={1} overrides={{ md: 3 }}>
              {data.map((card, index) => (
                <CardBase key={index} href={getAbsoluteUrl(`${card.url}`, pageConfig)}>
                  <Card.Body>
                    <Card.Accessories>
                      <Card.AccessoriesRow>
                        <Badge variant="outlined">{card.badge}</Badge>
                      </Card.AccessoriesRow>
                    </Card.Accessories>
                    <Card.Copy>
                      <Card.Headline tag="h3">{card.heading}</Card.Headline>
                    </Card.Copy>
                    <Card.Action>
                      <ButtonText iconEnd={ChevronRightIcon}>{card.buttonText}</ButtonText>
                    </Card.Action>
                  </Card.Body>
                </CardBase>
              ))}
            </ColumnTrack>
          </ColumnsWrapper>
        </Section.Contents>
      </StyledSection>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.mint[10]};
`

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
  }
`

const ColumnsWrapper = styled.div`
  margin-top: 60px;
`

export default Resources
